import { Branding, BrandingThemes } from 'branding'

const branding = new Branding()

export default { BrandingThemes: BrandingThemes[branding.branding] || BrandingThemes.default }
